module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "star",
    class: _vm.starType
  }, _vm._l((_vm.itemClasses), function(itemClass) {
    return _c('span', {
      staticClass: "star-item",
      class: itemClass
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c867adf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/star/Star.vue
// module id = 238
// module chunks = 1